import Link from 'next/link';
import Image from 'next/image';

export default function PodcastEpisodeCard({ episode }) {
  return (
    <div className="mb-12">

      {/* Thumbnail */}
      <div className="mb-4">
        <Link href={episode.link}>
          <div className="relative w-full h-64 lg:h-[500px] rounded-md overflow-hidden">

            {/* YouTube Thumbnail */}
            <Image
              src={`https://img.youtube.com/vi/${episode.youtubeId}/maxresdefault.jpg`}
              alt={`Modern Build Podcast Episode: ${episode.title}`}
              title={episode.title}
              fill
              sizes="(min-width: 1024px) 33vw, 100vw"
              className="object-cover rounded-md"
            />

            {/* Logo Overlay */}
            <div className="absolute left-1/2 bottom-1/3 transform -translate-x-1/2 w-44 h-44 md:w-48 md:h-48 rounded-md border-1 border-white overflow-hidden">
              <Image
                src="/podcast.webp"
                alt="Modern Build Logo"
                fill
                className="object-contain"
              />
            </div>

          </div>
        </Link>
      </div>

      {/* Content */}
      <div>
        <p className="text-sm text-gray mb-2">
          <span className="capitalize text-primary tracking-[3px]">
            {episode.author} / {episode.date}
          </span>
        </p>

        <h2 className="text-2xl font-light mb-3 font-gilda">
          <Link href={episode.link}>{episode.title}</Link>
        </h2>

        <p className="text-gray font-light mb-4">{episode.excerpt}</p>

        <Link href={episode.link}>
          <button
            aria-label="watch episode"
            className="bg-primary text-white px-6 py-3 text-md tracking-[3px] uppercase hover:bg-black hover:text-white transition duration-300"
          >
            Watch Episode
          </button>
        </Link>
      </div>
    </div>
  );
}
